<template>
    <div id="cover-details">
        <validation-observer ref="observer" tag="div" class="observer">
            <div
                class="grid grid-cols-6 mt-6"
                :class="{'gap-8' : form?.cover_type?.value !== COVER_TYPE.personalCover}"
            >
                <div class="col-span-6 w-full" v-if="showStartDateQuestion">
                    <validation-provider ref="start_date" name="start_date" rules="required|date_within_120"
                                         v-slot="{ errors }">
                        <div class="md:w-1/2">
                            <label for="start_date" class="block text-sm font-medium text-gray-700">
                                <span v-if="labelQuestion">When would you like your cover to start?</span>
                                <span v-else>Cover Start Date</span>
                            </label>


                            <date-picker mode="date" v-model="form.startDate.value"
                                         :popover="{ placement: 'bottom', visibility: 'click' }"
                                         :model-config="{type: 'string',mask: 'YYYY-MM-DD'}"
                                         :min-date="Date.now()"
                                         :max-date="form.startDate.max"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="relative">
                                        <input
                                            class="w-full mt-1 block rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                            :class="{
                            'border-2 border-red-300 placeholder-red-300':errors.length,
                            'border border-gray-300 ': !errors.length,
                        }"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            id="start_date"
                                            autocomplete="null"
                                        />
                                        <div class="absolute top-0 bottom-0 pr-4 right-0 pointer-events-none">
                                            <div class="flex items-center h-full text-gray-600">

                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                                                     fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                          clip-rule="evenodd"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </date-picker>
                        </div>

                        <p class="mt-2 text-sm text-red-600" v-if="errors.length">{{ errors[0] }}</p>
                        <p class="mt-2 text-sm text-gray-500" v-if="!errors.length">Your cover can start anytime <b>in
                            the
                            next 120 days</b></p>
                    </validation-provider>
                </div>
                <user-details
                    v-if="form?.cover_type?.value === COVER_TYPE.personalCover && !showAddtionalPeopleForm"
                    ref="userDetails"
                    :form="form"
                    :name.sync="form.name.value"
                    :surname.sync="form.surname.value"
                    :date-of-birth.sync="form.dateOfBirth"
                    :show-contact-detail="false"
                    :dob-error="dobError"
                    :dob-age-error="dobAgeError"
                    :day-value.sync="form.dateOfBirth.day.value"
                    :month-value.sync="form.dateOfBirth.month.value"
                    :year-value.sync="form.dateOfBirth.year.value"
                    @update:day="updateAccountHolder('day', $event)"
                    @update:month="updateAccountHolder('month', $event)"
                    @update:year="updateAccountHolder('year', $event)"
                ></user-details>

                <div v-else :key="key" v-for="(vehicle,key) in form.vehicles" class="col-span-6">
                    <validation-provider :ref="'vehicle__'+key" name="vrm" v-slot="{ errors }">
                        <div v-if="key > 0 && !labelQuestion" class="-mt-1 mb-6 border-t border-gray-200"></div> 
                        <div v-if="labelQuestion">
                            <span v-if="form.vehicles.length > 1 && key < 1"
                                  class="block col-span-6 text-sm font-medium text-gray-700 mb-4">What are the vehicles'
                                registrations?</span>
                            <label for="vrm" class="block text-sm font-medium text-gray-700">
                                <span v-if="form.vehicles.length == 1">
                                    What is the vehicle's registration?
                                </span>

                                <span v-if="form.vehicles.length > 1">
                                    {{ getOrdinalWord(key) }} vehicle
                                </span>
                            </label>
                        </div>
                        <div v-else>
                            <label for="vrm" class="block text-sm font-medium text-gray-700">
                                <span v-if="form.vehicles.length > 1">{{ getOrdinalWord(key) }}</span> Vehicle 
                            </label>
                        </div>

                        <div v-if="!vehicle.hidden" class="flex mt-1--" :class="{
                                'mt-1.5': form.vehicles.length > 1,
                                'mt-1': form.vehicles.length < 2,
                                'justify-between': !inputSmall
                            }">

                            <input v-model="vehicle.vrm.value" type="text" name="vrm"
                                   autocomplete="vrm"
                                   @input="onVrmChange(vehicle)"
                                   placeholder="ENTER REG"
                                   :data-key="key"
                                   maxlength="15"
                                   class="uppercase block  rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm focus:placeholder-transparent "
                                   :class="{
                                        'border-2 border-red-300 placeholder-red-300':(errors.length || !isVehicleValid(vehicle)),
                                        'border border-gray-300 ': !(errors.length || !isVehicleValid(vehicle)),
                                        'w-full': !inputSmall,
                                        'w-full md:w-1/2 ': inputSmall
                                    }"
                            >
                            <button @click="lookupAndValidateVrm(vehicle, key)" type="button"

                                    id="lookup-button"
                                    dusk="D-lookupVehicle"
                                    class="white-label-btn-text ml-2 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-none font-medium rounded-md shadow-sm text-black bg-cyan focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-poppins"
                                    :class="{
                                        'lg:invisible lg:opacity-50 cursor-default':!vehicle.vrm.value,
                                        'cursor-pointer':vehicle.vrm.value,
                                        'text-white':whiteButtonText
                                    }"

                            >
                                Lookup
                            </button>
                        </div>

                        <div class="" v-if="vehicle.result && !vehicle.manual" :class="{
                        'mt-3': labelQuestion,
                        'mt-1': !labelQuestion
                    }">
                          
                        <vehicle-card v-if="vehicle.hidden" :vehicle="vehicle.result"></vehicle-card>
                          <div v-if="vehicle.hidden" id="test-id">
                            <div 
                            v-if="vehicle.result && vehicleBetween21and24(vehicle.year.value) && extraVehicleWordingForOlderVehicles"
                            class="flex items-center text-left mt-2 mb-2">
                            <div class="text-xxs sm:text-sm font-base text-gray-500 py-1 md:py-0">
                                 <span class="flex items-center">
                                      <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2">
                                       <g transform="translate(-16 0.005)">
                                      <path
                                          d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                          class="shield-check-a"
                                      />
                                      <path
                                          d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                          class="shield-check-b"
                                          transform="translate(-75.994 -127.76)"
                                      />
                                      </g>
                                      </svg>
                                        <span class="text-sm text-gray-500 hidden md:inline-block">
                                           Your vehicle is over 20 years old - unlike most providers, we’re happy to cover it
                                        </span>
                                        <span class="text-sm text-gray-500 inline-block md:hidden">
                                           We cover 20+ year old vehicles - unlike most providers
                                        </span>
                                  </span>
                              </div>
                              </div>
                          </div>
                          
                          <div class="mt-6" v-if="vehicle?.result?.primaryError || (vehicle?.result?.nonBusinessError && !isBusinessFlow()) || vehicleTooOld">
                            
                            <div v-if="vehicle?.result?.primaryError || vehicle?.result?.nonBusinessError ||  checkIfVehicleIsTooOld(vehicle.year.value, isBusinessFlow())"
                                :class="{
                                   'bg-red-50 border-l-4 border-red-400 p-4' : vehicle?.result?.primaryError === 'AboveMaxAge' || checkIfVehicleIsTooOld(vehicle.year.value, isBusinessFlow()),
                                    'bg-yellow-50 border-l-4 border-yellow-400 p-4' : vehicle?.result?.primaryError && vehicle?.result?.primaryError !== 'AboveMaxAge' || (vehicle?.result?.nonBusinessError && !isBusinessFlow()) || vehicleMotorhomeRegex(vehicle.result) && !vehicle?.vrm?.error}"                            >
                              <div class="flex">
                                  <div class="flex-shrink-0">
                                    <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                      <path fill-rule="evenodd"
                                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                            clip-rule="evenodd"/>
                                    </svg>
                                  </div>
                                
                                <div v-if="vehicle?.result?.primaryError || checkIfVehicleIsTooOld(vehicle.year.value, isBusinessFlow())" class="ml-3">
                                    <p class="font-medium-- text-yellow-700 text-sm md:text-base" v-if="vehicle?.result?.primaryError">
                                      {{vehicle?.result?.vehicleErrorMessage}}
                                    </p>
                                    
                                    <p class="font-medium-- text-yellow-700 text-sm md:text-base" v-else-if="checkIfVehicleIsTooOld(vehicle.year.value, isBusinessFlow())">
                                      Unfortunately, we cannot offer breakdown cover for vehicles over
                                      {{ isBusinessFlow() ? '20' : '25' }} years old.
                                      If you believe this information is incorrect, please contact our support team and we will be happy to check.
                                    </p>
                                  
                                  
                                  </div>
                                
                                  <div v-if="(vehicle?.result?.nonBusinessError && !isBusinessFlow()) || vehicleMotorhomeRegex(vehicle.result) && !vehicle?.vrm?.error">
                                    <div class="ml-3">
                                      <p class="text-sm text-yellow-700 mb-2">
                                        This is a quote for Personal Breakdown Cover.
                                        <a v-if="whiteLabel" :href="whiteLabel.businessRoutePath"
                                           class="font-medium underline text-yellow-700 hover:text-yellow-600">
                                          If you're looking for Business Breakdown Cover, click here.
                                        </a>
                                        <a v-else href="/limitedtimebusiness"
                                           class="font-medium underline text-yellow-700 hover:text-yellow-600">
                                          If you're looking for Business Breakdown Cover, click here.
                                        </a>
                                      </p>
                                      <p class="text-sm text-yellow-700">
                                        For Campervan or Motorhome cover call <span class="font-medium">{{ phoneNumber }}</span> between 9am - 5pm Mon - Fri.
                                      </p>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <vehicle-error-card v-for="error in vehicle?.result?.otherVehicleError" :key="error" :message-key="error" />
                          
                        <div class="flex justify-between mt-2">
                            <a href="javascript:void(0)" @click="removeVehicle(key)"
                               v-if="key || form.vehicles.length > 1"
                               class="hover:underline text-gray-500 inline-block text-sm font-bold"
                               :dusk="`D-removeVehicle-${key}`">
                                Remove
                            </a>
                            <a href="javascript:void(0)" @click="toggleManualVehicle(key)"
                               dusk="D-NotTheRightVehicle"
                               class="hover:underline text-gray-500 inline-block text-sm font-bold"
                               :class="{'hidden': fixedPackage && vehicle.vrm.error == 'Vehicle registration has changed, please lookup again'}"
                               >
                                Not the right vehicle?
                            </a>
                        </div>

                        </div>
                        <div v-else-if="key">
                            <div class="flex justify-between mt-2">
                                <u href="javascript:void(0)" @click="removeVehicle(key)"
                                class="hover:underline text-gray-500 inline-block text-sm font-bold">
                                    Remove
                                </u>
                                <a v-if="key > 0 && vehicle?.vrm?.error && vehicle?.vrm?.error == cantFindVehicleText" href="javascript:void(0)" @click.stop.prevent="toggleManualVehicle(key, true)"
                                class="hover:underline text-gray-500 inline-block text-sm font-bold" dusk="D-ManuallyAddVehicle" id="manual-add-vehicle-btn">
                                    Manually Add Vehicle
                                </a>
                            </div>
                        </div>
                        <p class="mt-2 text-sm text-red-600" v-if="errors.length">{{ errors[0] }}</p>
                        <p class="mt-2 text-sm text-red-600" v-else-if="validationRan && !isVehicleValid(vehicle) && vehicle.vrm.value && !vehicle.lookedUp">
                            Please confirm your vehicle by looking up your reg
                        </p>
                        <p v-else-if="hideLookup == false"></p>
                        <p v-if="key === 0 && !vehicle.hidden && !fixedPackage" class="mt-2 text-sm text-gray-500">
                            <b>We cover vehicles</b> irrespective of who is behind the wheel
                        </p>
                        <div class="mt-2 flex justify-between" v-if="vehicle.vrm.error">
                            <div class="flex flex-col">
                                <!-- Add remove button if we have more than one vehicle, allow to remove the first vehicle if have errors. -->
                                <a href="javascript:void(0)" @click="removeVehicle(key)"
                                v-if="(form.vehicles.length > 1 && vehicle?.vrm?.error && key == 0)"
                                class="hover:underline text-gray-500 inline-block text-sm font-bold"
                                :class="{'hidden': fixedPackage && vehicle.vrm.error == 'Vehicle registration has changed, please lookup again'}"
                                >
                                    Remove
                                </a>
                                <p class="mt-2 text-sm text-red-600" dusk="D-cantFindThisVehicleWarning" >{{ vehicle.vrm.error }}</p>
                            </div>
                            <a v-if="key <= 0 && vehicle?.vrm?.error && vehicle?.vrm?.error == cantFindVehicleText" href="javascript:void(0)" @click.stop.prevent="toggleManualVehicle(key, true)"
                            class="hover:underline text-gray-500 inline-block text-sm font-bold mt-2" dusk="D-ManuallyAddVehicle" id="manual-add-vehicle-btn">
                            Manually Add Vehicle
                        </a>
                        </div>

                        <p v-if="key === 0 && !vehicle.hidden && fixedPackage && !hideFourVehicleMessage" class="mt-2 text-sm text-gray-500">
                           You can add cover for <b> up to 4 vehicles </b>
                        </p>

                    </validation-provider>


                    <div class="mt-4 col-span-6 grid grid-cols-6 gap-4" v-if="vehicle.manual">
                        <div class="col-span-6 sm:col-span-3">
                            <validation-provider ref="make" name="make" rules="required" v-slot="{ errors }">

                                <label for="make" class="block text-sm font-medium text-gray-700">Make</label>
                                <input v-model="vehicle.make.value" type="text" name="make"
                                    class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    :class="{
                                        'border-2 border-red-300 placeholder-red-300':errors.length,
                                        'border border-gray-300 ': !errors.length,
                                    }"
                                >
                                <p class="mt-2 text-sm text-red-600" v-if="errors.length">{{ errors[0] }}</p>

                            </validation-provider>

                        </div>
                        <div class="col-span-6 sm:col-span-3">
                            <validation-provider ref="model" name="model" rules="required" v-slot="{ errors }">

                                <label for="model" class="block text-sm font-medium text-gray-700">Model</label>
                                <input v-model="vehicle.model.value" type="text" name="model"
                                    class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    :class="{
                                        'border-2 border-red-300 placeholder-red-300':errors.length,
                                        'border border-gray-300 ': !errors.length,
                                    }"
                                >
                                <p class="mt-2 text-sm text-red-600" v-if="errors.length">{{ errors[0] }}</p>

                            </validation-provider>
                        </div>

                        <div class="col-span-6 sm:col-span-3">
                            <validation-provider ref="year" name="year" rules="required|year" v-slot="{ errors }">

                                <label for="year" class="block text-sm font-medium text-gray-700">Year</label>
                                <input v-model="vehicle.year.value" type="text" name="year" min="0" pattern="[0-9]*" maxlength="4" inputmode="numeric"
                                    class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                    :class="{
                                        'border-2 border-red-300 placeholder-red-300':errors.length,
                                        'border border-gray-300 ': !errors.length,
                                    }"
                                >
                                <p class="mt-2 text-sm text-red-600" v-if="errors.length">{{ errors[0] }}</p>

                            </validation-provider>
                        </div>

                        <div class="col-span-6 sm:col-span-3">
                                <label for="update" class="block text-sm font-medium text-gray-700">&nbsp;</label>
                                <button @click.stop.prevent="updateManualVehicle(key, vehicle)" class="mt-1 block rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 border bg-cyan hover:bg-cyan-700 text-black font-medium text-sm w-1/3 xl:w-1/4" :disabled="!isMakeFilled || !isModelFilled || !isYearFilled" dusk="D-saveManualVehicle">
                                    Save
                                </button>
                        </div>
                    </div>
                </div>

                <div class="col-span-6 flex justify-end -mt-4"
                     v-if="(form.vehicles.length && form.vehicles[0].result && form.vehicles.length < form.vehicle.max) || hasVehicleBeenRemoved">

                    <button @click="addEmptyVehicle()" type="button" dusk="D-addAnotherVehicle"
                            class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                        Add another vehicle
                    </button>
                </div>

            </div>
        </validation-observer>
      
      <div class="mt-2 flex justify-end" v-if="this.addEmptyVehicleError !== ''">
        <p class="mt-2 text-sm text-red-600">{{ this.addEmptyVehicleError }}</p>
      </div>
      
    </div>
</template>

<script>
import VehicleCard from "../VehicleCard"
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import vOutsideEvents from 'vue-outside-events'
import commonMethods from "../../common/methods"
import PersonalDetails from "./PersonalDetails.vue"
import UserDetails from './UserDetails.vue'
import { COVER_TYPE } from "../../constants";
import VehicleErrorCard from "../VehicleErrorCard.vue";
import {
  isValidVrm,
  missingFieldErrorText,
  vehicleMotorhomeRegex,
  suggestCorrectedVRM,
  checkIfVehicleIsTooOld
} from "../../common/vehicleMethods";
import {mapGetters} from "vuex";

window.Vue.use(vOutsideEvents)

export default {
    name: "CoverDetails",
    components: {
        VehicleCard,
        DatePicker,
        PersonalDetails,
        UserDetails,
        VehicleErrorCard
    },
    computed: {
        allVehiclesLookedUp() {
            return this.form.vehicles.every(item => item.lookedUp && !item.vrm?.error);
        },
      ...mapGetters({
        vehicles: 'vehicles',
      }),
    },
    props: {
        form: {
            type: Object,
            default: () => {
            },
        },
        inputSmall: {
            type: Boolean,
            default: false,
        },
        labelQuestion: {
            type: Boolean,
            default: false,
        },
        whiteLabel: {
            type: Object || String,
            default: () => {
            },
        },
        phoneNumber:{
            type: String,
            default: '0330 113 2433'
        },
        showStartDateQuestion: {
            type: Boolean,
            default: true,
        },
        whiteButtonText: {
            type: Boolean,
            default: false
        },
        hideLookup: {
            type: Boolean,
            default: true
        },
        dobError: {
            type: Boolean,
            default: false
        },
        dobAgeError: {
            type: Boolean,
            default: false
        },
        // this need checking ---------------
        showAddtionalPeopleForm: {
            type: Boolean,
            default: false
        },
        fixedPackage: {
            type: Boolean,
            default: false,
        },
        hideFourVehicleMessage: {
            type: Boolean,
            default: false,
        },
        isDetailsPage: {
            type: Boolean,
            default: false,
        },
        extraVehicleWordingForOlderVehicles: {
        type: Boolean, 
        default: false
      }
    },
    data() {
        return {
            validationRan: false,
            COVER_TYPE: COVER_TYPE,
            isMakeFilled: false,
            isModelFilled: false,
            isYearFilled: false,
            cantFindVehicleText: "Can't find this vehicle",
            addEmptyVehicleError: '',
            hasVehicleBeenRemoved: false,
            vehicleTooOld: false,
        }
    },
    methods: {
      checkIfVehicleIsTooOld,
        ...commonMethods,
        vehicleMotorhomeRegex,
        updatePeople(index, field, value) {
            this.$store.commit('UPDATE_PEOPLE', { index, field, value });
        },
        updateAccountHolder(dobField, value) {
            this.form.dateOfBirth[dobField].value = value
        },
        async onVrmBlur(e, el) {
            const vehicle = this.form.vehicles[el.dataset.key]
            if (!vehicle.vrm.value) {
                return
            }
            if (vehicle.lookedUp) {
                return
            }
            if (e.target.id === 'lookup-button') {
                return
            }
            await this.lookupAndValidateVrm(vehicle, el.dataset.key)

        },
        async lookupAndValidateVrm(vehicle, key) {
          this.addEmptyVehicleError = '';
          if(vehicle.vrm.value && !isValidVrm(vehicle.vrm.value)){
                // check if vrm is 7 characters without space before suggesting
                const cleanedVrm = vehicle.vrm.value.replace(/\s+/g, '').toUpperCase()
                if(cleanedVrm.length == 7){
                    const {suggestion, hasChanged, validVrm } = suggestCorrectedVRM(vehicle.vrm.value)
                    if(hasChanged && validVrm) {
                        vehicle.vrm.value = suggestion
                        await this.lookupVrm(vehicle, key)   
                    } else {
                        this.$set(vehicle.vrm, 'error', 'Please enter a valid vehicle registration');
                    }
                } else {
                    this.$set(vehicle.vrm, 'error', 'Please enter a valid vehicle registration');
                }
                this.$forceUpdate()
                return
            } else if (vehicle.vrm.value && isValidVrm(vehicle.vrm.value) && vehicle.lookedUp && vehicle.vrm.error !== "Can't find this vehicle") {
                // edge case - when lookedup but missing fields, only save vehicle if fields are filled in
                this.updateManualVehicle(key, vehicle)
            } else {
                this.$set(vehicle.vrm, 'error', '');
                await this.lookupVrm(vehicle, key)
            }
        },
        checkVehicleFields(key) {
            const vehicle = this.form.vehicles[key];

            this.isMakeFilled = vehicle.make.value && vehicle.make.value.length > 0;
            this.isModelFilled = vehicle.model.value && vehicle.model.value.length > 0;
            this.isYearFilled = vehicle.year.value && vehicle.year.value.length === 4 && vehicle.year.value > 1900;

            if((!this.isMakeFilled || !this.isModelFilled || !this.isYearFilled) && !this.fixedPackage) {
                this.validationRan = false
            } else if(this.isMakeFilled && this.isModelFilled && this.isYearFilled && !this.fixedPackage && vehicle.lookedUp) {
                vehicle.vrm.error = null
            }

        },
        updateManualVehicle(key, vehicle) {
            if((!vehicle.vrm.value || !vehicle.year.value || !vehicle.make.value || !vehicle.model.value) && this.isCoveredVehicleType(vehicle?.result)) {
                return
            }

            if (this.form.vehicles.find((item, index) => {
                return item.vrm.value === vehicle.vrm.value && (key !== index)
            })){
                vehicle.vrm.error = 'This vehicle has already been added.'
                this.$forceUpdate();
                return false
            }

            this.$store.commit('UPDATE_VEHICLE_DETAILS', {
                key,
                vrm: vehicle.vrm.value,
                make: vehicle.make.value,
                model: vehicle.model.value,
                year: vehicle.year.value
            });
            if(vehicle.result) {
                vehicle.result.vrm = this.form.vehicles[key].vrm.value
                vehicle.result.year = this.form.vehicles[key].year.value
                vehicle.result.make = this.form.vehicles[key].make.value
                vehicle.result.model = this.form.vehicles[key].model.value
            } else {
                // check for (vehiclemake/model/year && !uncoveredVehicle ) OR uncoveredVehicle
                // if vehicle is not found - result is also not defined so we need to recreate an object fir the make, model and year
                vehicle = {
                    result: {
                        year: this.form.vehicles[key].year.value,
                        make: this.form.vehicles[key].make.value,
                        model: this.form.vehicles[key].model.value,
                        vrm: this.form.vehicles[key].vrm.value,
                    }
                };
                this.form.vehicles[key] = {
                    ...this.form.vehicles[key],
                    result: {
                        year: this.form.vehicles[key].year.value,
                        make: this.form.vehicles[key].make.value,
                        model: this.form.vehicles[key].model.value,
                        vrm: this.form.vehicles[key].vrm.value,
                    },
                    vrm: {
                        ...this.form.vehicles[key].vrm
                    }
                }
            }
            
          this.vehicleTooOld = false;
          this.vehicleTooOld = checkIfVehicleIsTooOld(this.form.vehicles[key].year.value, this.isBusinessFlow());
          
          if(!this.vehicleTooOld){
            this.form.vehicles[key].result.primaryError = null;
            this.form.vehicles[key].result.nonBusinessError = null;
            this.form.vehicles[key].result.vehicleErrorMessage = null;
          }
          
            this.manuallySaveVehicle(this.form.vehicles)
            this.toggleManualVehicle(key, true)
        },
        isVehicleValid(vehicle) {
          if(vehicle.vrm.error){
                return false
            }
            if (!this.validationRan) {
              return true
            }
            if(!(vehicle.result || vehicle.manual) && !this.fixedPackage) {
                this.validationRan = false
            }
            return (vehicle.result || vehicle.manual)
        },
        async validates(isDetailsPage = false) {
          
          const isVehicleTooOld = this.form.vehicles.some(v => checkIfVehicleIsTooOld(v.year?.value, this.isBusinessFlow()));
          
          if (isDetailsPage || isVehicleTooOld) {             
            await this.lookupAll()
            
            const hasVrmError = this.form.vehicles.some(v =>
                v.vrm?.error || isVehicleTooOld);
            
                if (hasVrmError) {
                    return false
                }
            }

            if(this.fixedPackage) {
                // Check if VRM has changed after already looked up
                const vrmChange = this.form.vehicles.every(item => item.lookedUp)

                if (!vrmChange) {
                    return
                }

                this.validationRan = true
            } else {
                this.allVehiclesValid()
            }
            return await this.$refs.observer.validate()
        },
        allVehiclesValid() {
          for (let i = 0; i < this.form.vehicles.length; i++) {
                let item = this.form.vehicles[i]
                if (!this.isVehicleValid(item)) {
                    this.validationRan = false
                    return false
                }
                
                if(item?.result?.primaryError === 'AboveMaxAge' || (item?.result?.otherVehicleError && item?.result?.otherVehicleError?.length > 0)){
                    return false;
                }
            }
            return true
        },
        async lookupAll() {
            for (let i = 0; i < this.form.vehicles.length; i++) {
                let item = this.form.vehicles[i]
                if (!item.lookedUp) {
                    await this.lookupAndValidateVrm(item, i)
                // edge case - save lookup vehicle on get your quote button after filling in all fields for missing fields and close the form
                } else if (item.lookedUp && !item.vrm.error && item.manual ) {
                    this.updateManualVehicle(i, item)
                }
            }
        },
        async addEmptyVehicle() {
            for (let i = 0; i < this.form.vehicles.length; i++) {
                let item = this.form.vehicles[i]
                const missingFields = !item.make.value || !item.model.value || !item.year.value

                if (missingFields && item.result && this.isCoveredVehicleType(item.result)){
                    const itemObj = {
                        make: item.make.value,
                        model: item.model.value,
                        year: item.year.value,
                    }
                    item.vrm.error = missingFieldErrorText(itemObj);
                }
              
              if(!item.manual && missingFields){
                this.addEmptyVehicleError = 'Please complete vehicle details above before adding another.';
                return
              }
              
              if(this.item === undefined && !item.manual){
                this.addEmptyVehicleError = '';
              }
            }
            this.$emit('add-empty-vehicle', true)
            
            if (this.isDetailsPage) {
                if (this.form.vehicles.length >= this.$store.state.quote.no_vehicles) {
                    this.$store.commit('VEHICLES_REMOVED', false)
                    this.hasVehicleBeenRemoved = false
                }
            }
        },
        isCoveredVehicleType(result) {
            if (result == null) {
                return true
            }
          
            if(result.primaryError !== null || result.nonBusinessError !== null){
            return false
            } else {
            return true
            }
        },
        removeVehicle(key) {
            this.addEmptyVehicleError = '';
            this.$emit('remove-vehicle', key)

            if (this.isDetailsPage) {
                this.$store.commit('VEHICLES_REMOVED', true)
                this.hasVehicleBeenRemoved = true
            }
        },
        onVrmChange(vehicle) {
            vehicle.lookedUp = false
            
            if(vehicle?.result){
              vehicle.result.primaryError = null;
              vehicle.result.nonBusinessError = null;
              vehicle.result.vehicleErrorMessage = null;
              
            }
          
            if(vehicle?.result?.otherVehicleError && vehicle?.result?.otherVehicleError?.length > 0){
              vehicle.result.otherVehicleError = [];
            }
          
            if (this.fixedPackage) {
                if (this.validationRan) {
                    vehicle.vrm.error = null
                } else if (vehicle.result) {
                    vehicle.vrm.error = 'Vehicle registration has changed, please lookup again'
                    vehicle.manual = false
                }
            }
        },
          async validateUserDetails() {

            if (this.$refs.userDetailsExtraPeople) {
                for (let ref of this.$refs.userDetailsExtraPeople) {
                    if (ref && typeof ref.validates === 'function') {
                        const dobExtraPeople = await ref.validates()
                        if (!dobExtraPeople) {
                            return false
                        }
                    }
                }
            } else if (this.$refs.userDetails) {
                const ref = this.$refs.userDetails
                if (ref && typeof ref.validates === 'function') {
                    const dobValidate = await ref.validates()
                    if (!dobValidate) {
                        return false
                    }
                }
            }

            return true;
        },
        getOrdinalWord(index) {
            const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth','Seventh', 'Eighth', 'Ninth', 'Tenth'];
            return ordinals[index] || `${index + 1}th`;
        }, 
        vehicleBetween21and24(year){
        
          const currentYear = new Date().getFullYear();
          let diffInYears = currentYear - year;
          
          return !this.isBusinessFlow() && diffInYears >= 20 && diffInYears <= 25;
        }
    },
      mounted() {
        // If vuex store has removed vehicles - allow the user to add their vehicle(s) back in.
        if(this.isDetailsPage && this.$store.state.vehicles_removed) {
            this.hasVehicleBeenRemoved = true
        }
      this.vehicleTooOld = this.vehicles.some(v => checkIfVehicleIsTooOld(v.year, this.isBusinessFlow()));
    },
    watch: {
        'form.vehicles': {
            handler(newVehicles) {
                newVehicles.forEach((vehicle, index) => {
                    if (vehicle.manual) {
                        this.checkVehicleFields(index);
                    }
                });
            },
            deep: true,
            immediate: true
        },
    }
}

</script>

<style scoped>

</style>
